import { render } from "./StateLabel.vue?vue&type=template&id=8431206a&scoped=true"
import script from "./StateLabel.vue?vue&type=script&lang=js"
export * from "./StateLabel.vue?vue&type=script&lang=js"

import "./StateLabel.vue?vue&type=style&index=0&id=8431206a&scoped=true&lang=less"
/* custom blocks */
import block0 from "@/locales/StateLabel.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuildhome%2Frepo%2Fsrc%2Fcomponents%2FStateLabel.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.0_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8431206a"]])

export default __exports__